/** Shared helpers for DealHunt `enrichment.videos` (used by the PDP gallery + Videos section). */
import type { DealHuntVideo } from './types'

/** Best playable URL for a video, or null when none is available. */
export function videoHref(v: DealHuntVideo): string | null {
  if (v.videoUrl) {
    return v.videoUrl
  }
  if (v.url) {
    return v.url
  }
  return v.videoId ? `https://www.youtube.com/watch?v=${v.videoId}` : null
}

const TYPE_LABELS: Record<string, string> = {
  review: 'Review',
  comparison: 'Comparison',
  hands_on: 'Hands-on',
  unboxing: 'Unboxing',
  short: 'Short',
}

/** Human label for DealHunt `videoType` ("comparison" -> "Comparison"), or null. */
export function videoTypeLabel(type: string | null | undefined): string | null {
  if (!type) {
    return null
  }
  return TYPE_LABELS[type] ?? type.replace(/[_-]+/g, ' ').replace(/\b\w/g, c => c.toUpperCase())
}

/** Seconds -> "m:ss", or null when unknown. */
export function formatVideoDuration(seconds: number | null | undefined): string | null {
  if (seconds === null || seconds === undefined || !Number.isFinite(seconds)) {
    return null
  }
  const m = Math.floor(seconds / 60)
  const s = String(Math.floor(seconds % 60)).padStart(2, '0')
  return `${m}:${s}`
}
